var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMerchantStoreInstore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "merchantStore-instore"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    d: "M4.5 4.25C4.5 3.83579 4.83579 3.5 5.25 3.5H18.75C19.1642 3.5 19.5 3.83579 19.5 4.25V8.75C19.5 9.16421 19.1642 9.5 18.75 9.5H16.5V11H20.25C20.6642 11 21 11.3358 21 11.75V21.5H21.75C22.1642 21.5 22.5 21.8358 22.5 22.25C22.5 22.6642 22.1642 23 21.75 23H2.25C1.83579 23 1.5 22.6642 1.5 22.25C1.5 21.8358 1.83579 21.5 2.25 21.5H3V11.75C3 11.3358 3.33579 11 3.75 11H7.5V9.5H5.25C4.83579 9.5 4.5 9.16421 4.5 8.75V4.25ZM13.5 16.25C14.3284 16.25 15 16.9216 15 17.75V21.5H19.5V12.5H4.5V21.5H9V17.75C9 16.9216 9.67157 16.25 10.5 16.25H13.5ZM18 5H6V8H18V5ZM9 9.5V11H15V9.5H9Z",
    fill: "#18223D"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerchantStoreInstore);
export default __webpack_public_path__ + "static/media/merchantStore-instore.9ffde6c61e952c17220c3e4a49c2a6f1.svg";
export { ForwardRef as ReactComponent };